import http from "../http";
import Service from "../../Service";
import StoreService from "../stores/store.service";

export default class SellerOrderService extends Service {
    list(params) {
        return http.get("v2/clients/requisitions", {
            headers: this.getHeaders(),
            params,
        });
    }

    options() {
        return new StoreService().load().then(({ data }) => {
            const stores = Array.isArray(data) ? data : data.data || [];
            return { data: { stores: stores.map((store) => ({ value: store.id, label: store.name })) } };
        });
    }

    create(payload) {
        return http.post("v2/clients/requisitions", payload, {
            headers: this.getHeaders(),
        });
    }

    update(id, payload) {
        return http.patch(`v2/clients/requisitions/${id}`, payload, {
            headers: this.getHeaders(),
        });
    }

    cancel(id) {
        return http.delete(`v2/clients/requisitions/${id}`, {
            headers: this.getHeaders(),
        });
    }

    show(id, params) {
        return http.get(`v2/clients/requisitions/${id}`, {
            headers: this.getHeaders(),
            params,
        });
    }

    products(id, params) {
        return http.get(`v2/clients/requisitions/${id}/products`, {
            headers: this.getHeaders(),
            params,
        });
    }

    exportProducts(id, params) {
        return http.get(`v2/clients/requisitions/${id}/products`, {
            headers: this.getHeaders(),
            params: { ...params, export: "xlsx" },
            responseType: "blob",
        });
    }

    searchProducts(id, params) {
        return http.get(`v2/clients/requisitions/${id}/products/search`, {
            headers: this.getHeaders(),
            params,
        });
    }

    refreshErp(id, lineIds, algorithm) {
        const payload = { ...(lineIds ? { line_ids: lineIds } : {}), ...(algorithm ? { algorithm } : {}) };
        return http.post(`v2/clients/requisitions/${id}/products/erp-refresh`, payload, {
            headers: this.getHeaders(),
        });
    }

    addProduct(id, payload) {
        return http.post(`v2/clients/requisitions/${id}/products`, payload, {
            headers: this.getHeaders(),
        });
    }

    approve(id, resupply = false) {
        return http.post(`v2/clients/requisitions/${id}/approve`, resupply ? { resupply: true } : {}, {
            headers: this.getHeaders(),
        });
    }

    reject(id, reason) {
        return http.post(`v2/clients/requisitions/${id}/reject`, { reason }, {
            headers: this.getHeaders(),
        });
    }

    updateProduct(id, lineId, payload) {
        return http.patch(`v2/clients/requisitions/${id}/products/${lineId}`, payload, {
            headers: this.getHeaders(),
        });
    }

    removeProduct(id, lineId) {
        return http.delete(`v2/clients/requisitions/${id}/products/${lineId}`, {
            headers: this.getHeaders(),
        });
    }
}
